"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPermissions = void 0;
/**
 * Helper function to check if a permission level includes the required level
 * @param perm - The permission level to check
 * @param required - The required permission level
 */
const hasPermission = (perm, required) => {
    if (!perm)
        return false;
    if (perm === 'all')
        return true;
    if (required === 'read' && perm === 'update')
        return true;
    return perm === required;
};
/**
 * Returns a set of permission checkers based on the user's permissions
 * @param users - Users data from useGetInternalPortalV1UsersQuery
 * @returns Object with permission checkers
 */
const getPermissions = (users) => {
    const usersMod = users;
    const permissions = usersMod?.permissions;
    return {
        // Customer search permissions
        hasCustomerSearchRead: () => hasPermission(permissions?.customerSearch, 'read'),
        hasCustomerSearchUpdate: () => hasPermission(permissions?.customerSearch, 'update'),
        // Location permissions
        hasLocationUpdate: () => hasPermission(permissions?.location, 'update'),
        // Location enrollment permissions
        hasLocationEnrollmentUpdate: () => hasPermission(permissions?.locationEnrollment, 'update'),
        hasLocationEnrollmentRead: () => hasPermission(permissions?.locationEnrollment, 'read'),
        // Location status permissions
        hasLocationStatusUpdate: () => hasPermission(permissions?.locationStatus, 'update'),
        // Location digital receipt permissions
        hasLocationDigitalReceiptUpdate: () => hasPermission(permissions?.locationDigitalReceipt, 'update'),
        // Location OTA permissions
        hasLocationOtaUpdate: () => hasPermission(permissions?.locationOta, 'update'),
        // Credit application permissions
        hasCreditApplicationUpdate: () => hasPermission(permissions?.creditApplication, 'update'),
        // Location waterfall permissions
        hasLocationWaterfallUpdate: () => hasPermission(permissions?.locationWaterfall, 'update'),
        // Location store link campaigns permissions
        hasLocationStoreLinkCampaignRead: () => hasPermission(permissions?.storeLinkCampaign, 'read'),
    };
};
exports.getPermissions = getPermissions;
